import { FC, useState, createContext } from 'react';
import LoadingOverlay from "../components/LoadingOverlay";
type LoadingOverlayContext = {
    shown: boolean,
    show: () => void,
    hide: () => void
}

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const LoadingOverlayContext = createContext<LoadingOverlayContext>(
    {} as LoadingOverlayContext
);

const DELAY_TO_ACTIVATION_MS = 100;
const MINIMUM_PRESENCE_TIME_MS = 100;
let timeoutInstance;

export const LoadingOverlayProvider:FC = ({children}) => {
    const [shown, setShown] = useState<boolean>(false);

    const hide = () => {
        if (timeoutInstance) {
            clearTimeout(timeoutInstance);
        }

        setTimeout(() => {
            setShown(false);
        }, MINIMUM_PRESENCE_TIME_MS);
    }

    const show = () => {
        if (timeoutInstance) {
            clearTimeout(timeoutInstance);
        }

        timeoutInstance = setTimeout(() => {
            setShown(true);
        }, DELAY_TO_ACTIVATION_MS);
    }

    return (
        <LoadingOverlayContext.Provider value={{
            shown,
            show,
            hide
        }}>
            <LoadingOverlay active={shown} />
            {children}
        </LoadingOverlayContext.Provider>
    );
};
